module.exports = __webpack_public_path__ + "img/container-2.a184bb19.png";